
import Vue from 'vue';
import Header from '@/components/HeaderInternal/index.vue';
import Bradcrumb from '@/components/Bradcrumb/index.vue';
import Footer from '@/components/Footer/index.vue';
import { Container } from './styles';

export default Vue.extend({
  components: {
    Header,
    Bradcrumb,
    Footer,
    Container,
  },
  computed: {
    name() {
      const { routes } = this.$store.state;
      return routes.length > 0 ? routes[routes.length - 1].name : '';
    },
  },
});
